import { Button, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLookupInvoice extends Layout {
	buttonClassicCustomer: Button;
	buttonClassicInvoice: Button;
	labelC: Label;
	labelCity: Label;
	labelCustomerHeading: Label;
	labelCustomerName: Label;
	labelI: Label;
	panel1: Panel;
	panel2: Panel;
	panel3: Panel;
	sourceRenditionInvoice: DataSource;
	textboxAddress1: Label;
	textboxAmount: Textbox;
	textboxBalance: Textbox;
	textboxBillDate: Textbox;
	textboxContactName: Label;
	textboxEmail: Label;
	textboxId: Label;
	textboxPhone: Label;
}
